import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SDM17SP1 from './SDM17SP1';
import SDM17SPC from './SDM17SPC';
import BasicForm from './BasicForm';

class SensorDetail extends PureComponent {
    static propTypes = {
        moduleType: PropTypes.string.isRequired
    };

    static defaultProps = {};

    render() {
        const { moduleType } = this.props;

        const detailContentByType = {
            SDM17SP1: () => <SDM17SP1 {...this.props} />,
            SDM17SPC: () => <SDM17SPC {...this.props} />,
            default: () => null
        };
        return <BasicForm {...this.props}>{(detailContentByType[moduleType] || detailContentByType['default'])()}</BasicForm>;
    }
}
export default SensorDetail;



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/Sensor/index.js